export default ({ $wire, watch, modalEventName, itemId, location }) => ({
    isOpen: false,
    openTab: 'statistics',
    extraCostsOpenTab: 'no-credit',

    init() {
        window.addEventListener(modalEventName, event => {
            event.detail?.status === 'open' ? this.open(event.detail.tab, event.detail.subtab) : this.close();
        });
        this.$watch('openTab', value => {
            this.$dispatch('market-intelligence-modal-tab-changed', value);
        });
    },

    open(tab = null, subtab = null) {
        if (tab) this.setOpenTab(tab);
        if (subtab) this.setExtraCostsTab(subtab);
        this.isOpen = true;
        document.body.style.overflow = 'hidden';
    },

    close() {
        this.isOpen = false;
        document.body.style.overflow = 'auto';
    },

    setOpenTab(value) {
        this.openTab = value;
    },

    setExtraCostsTab(value) {
        this.extraCostsOpenTab = value;
    },
});
